import type { ProductionSlotRow, ProductionSlotsState } from "@/lib/sdtestapp/sdTestAppProductionClient";

type SlotAssignClient = {
  assignSlot: (slotName: string, connectorId: string | null) => Promise<ProductionSlotsState>;
};

/** Match NiceGUI batch rack swap: move connector onto target slot, swapping occupants when needed. */
export async function assignBenchRackSlotWithSwap(
  client: SlotAssignClient,
  slots: ProductionSlotRow[],
  targetSlotName: string,
  connectorId: string,
  sourceSlotName?: string | null,
): Promise<ProductionSlotsState> {
  const normalizedSource = String(sourceSlotName ?? "").trim();
  if (!normalizedSource) {
    return client.assignSlot(targetSlotName, connectorId);
  }

  const destinationCurrent =
    slots.find((slot) => slot.slotName === targetSlotName)?.connectorId?.trim() || null;

  if (destinationCurrent && destinationCurrent !== connectorId) {
    await client.assignSlot(normalizedSource, destinationCurrent);
  } else {
    await client.assignSlot(normalizedSource, null);
  }

  return client.assignSlot(targetSlotName, connectorId);
}
